<template>
  <div class="router-view customer-page-wrapper" id="router-view" style="height: 100%">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: "VueCustomerPageRoot",
};
</script>

<style lang="scss" scoped>
</style>
